import React from 'react';

const DM = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_164"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_164)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#006C3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7H0V8H10V15H11V8H21V7H11V0H10V7Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6V7H10V0H9V6H0V7H10V6H9ZM10 7H21V6H9V7H10V6H9V15H10V7Z"
        fill="#FDD200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9V8H11V15H12V9H21V8H11V9H12ZM0 8H13V9H0V8ZM11 0H12V9H11V0Z"
        fill="white"
      />
      <path
        d="M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
        fill="#D6172A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6H10V7H9V6ZM11 6H12V7H11V6ZM11 8H12V9H11V8ZM9 8H10V9H9V8Z"
        fill="#006C3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 6H11V8H10V6Z"
        fill="#955DCC"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default DM;
